export default "__VITE_ASSET__CLBbkeZi__"